import React from 'react'
import styled from 'styled-components'
import { styles } from '.'

export function Texte({ title, message }) {
  return (
    <TexteWrapper>
      <h3>{message}</h3>
      <h1>{title}</h1>
      <div className="underline" />
    </TexteWrapper>
  )
}
Texte.defaultProps = {
  message: 'our message',
  title: 'our title',
}

const TexteWrapper = styled.div`
  text-align: center;
  h3 {
    ${styles.textTitle};
    ${styles.letterSpacing({ spacing: '0.3rem' })};
    font-size: 2rem;
    color: ${styles.colors.mainYellow};
  }
  h1 {
    ${styles.letterSpacing({ spacing: '0.1rem' })};
    font-size: 1rem;
    text-transform: uppercase;
  }
  .underline {
    width: 5rem;
    height: 0.2rem;
    background: ${styles.colors.mainYellow};
    margin: 0.5rem auto;
  }
`
